import '../scss/main.scss'
import './_jump.setting'
import './_scrollmagic.setting'
import TabController from './modules/TabController'
import MenuController from './modules/MenuController'
import AccordionController from './modules/AccordionController'
import TagSearchAnimationController from './modules/TagSearchAnimationController'
import FormSearchAnimationController from './modules/FormSearchAnimationController'
import { fetchForumReactions, ForumReactions, handleReactionClick } from './modules/firebaseReaction'

window.addEventListener('load', () => {
  document.body.classList.add('__loaded')

  {
    /* sp-menu */
    const $container = document.querySelector(`[data-sp-menu-container]`) as HTMLElement
    if ($container !== null) {
      const spMenu = new MenuController($container, 'sp')
    }
  }

  {
    /* tab */
    const $container = document.querySelector(`[data-tab-container]`) as HTMLElement
    if ($container !== null) {
      const tab = new TabController($container)
    }
    // const tabs: TabController[] = (() => {
    //   const nodeList = document.querySelectorAll('[data-tab-container]')
    //   return Array.from(nodeList)
    //     .map(node => new TabController(node as HTMLElement))
    // })()
    // console.log(tabs)

    // const { hash } = window.location
    // if (hash.includes('#tabindex-') && tabs.length !== 0) {
    //   let tabindex = ''
    //   if (hash.includes('#anchor-')) {
    //     tabindex = hash.replace(/#anchor-.*?#tabindex-/, '')
    //   } else {
    //     tabindex = hash.replace('#tabindex-', '')
    //   }
    //   tabs[0].updateState(tabindex)
    // }
  }

  {
    /* accordion */
    const $accordions: AccordionController[] = (() => {
      const nodeList = document.querySelectorAll('[data-accordion-container]')
      return Array.from(nodeList)
        .map(node => new AccordionController(node as HTMLElement))
    })()
  }

  {
    /* form-search */
    const $formSearches: FormSearchAnimationController[] = (() => {
      const nodeList = document.querySelectorAll('[data-form-search-container]')
      return Array.from(nodeList)
        .map(node => new FormSearchAnimationController(node as HTMLElement))
    })()

    /* tag-search */
    const $tagSearches: TagSearchAnimationController[] = (() => {
      const nodeList = document.querySelectorAll('[data-tag-search-container]')
      return Array.from(nodeList)
        .map(node => new TagSearchAnimationController(node as HTMLElement))
    })()
  }

  {
    const root = document.querySelector<HTMLElement>('.js-ym-filter-container')
    if (!root) return
    const { postType } = root.dataset

    let selectedYear: string | null = null
    let selectedMonth: string | null = null

    const yearButtons = root.querySelectorAll<HTMLElement>('[data-year]')
    const monthButtons = root.querySelectorAll<HTMLElement>('[data-month]')
    const submitButton = root.querySelector<HTMLButtonElement>('.c-tag-search__submit')

    const updateSubmitState = () => {
      if (!submitButton) return
      if (selectedYear && selectedMonth) {
        submitButton.disabled = false
      } else {
        submitButton.disabled = true
      }
    }

    yearButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        selectedYear = btn.dataset.year ?? null

        yearButtons.forEach((b) => b.classList.remove('--active'))
        btn.classList.add('--active')

        updateSubmitState()
      })
    })

    monthButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        selectedMonth = btn.dataset.month?.padStart(2, '0') ?? null

        monthButtons.forEach((b) => b.classList.remove('--active'))
        btn.classList.add('--active')

        updateSubmitState()
      })
    })

    submitButton?.addEventListener('click', () => {
      if (selectedYear && selectedMonth) {
        const ym = `${selectedYear}-${selectedMonth}`
        const url = new URL(window.location.href)
        url.searchParams.delete('s')
        url.searchParams.delete('period')
        url.searchParams.set('ym_filter', ym)
        window.location.href = url.toString()
      }
    })
  }

  void (async () => {
    const containers = document.querySelectorAll<HTMLElement>('.js-forum-reactions-container')
    if (!containers.length) return

    await Promise.all(
      Array.from(containers).map(async (container) => {
        const { forumId } = container.dataset
        if (!forumId) return

        try {
          const reactions: ForumReactions = await fetchForumReactions(forumId)

          const elements = container.querySelectorAll<HTMLElement>('.reaction-count')
          elements.forEach((el) => {
            const type = el.getAttribute('data-type')
            if (type && reactions[type] !== undefined) {
              el.textContent = String(reactions[type])
            }
          })
        } catch (error) {
          console.error(`Failed to fetch reactions for forumId: ${forumId}`, error)
        }
      })
    )
  })()

  {
    const containers = document.querySelectorAll<HTMLElement>('.js-forum-reactions-container')
    if (!containers.length) return

      Array.from(containers).forEach((container) => {
        const { forumId } = container.dataset
        if (!forumId) return

        // await updateReactionCounts(container, forumId)

        // 各カウント要素にクリックイベント追加
        const buttons = container.querySelectorAll<HTMLElement>('.forum-reaction-button')
        buttons.forEach((el) => {
          el.addEventListener('click', () => handleReactionClick(el))
        })
      })
  }
})
